export default __webpack_public_path__ + "static/media/booth.3eccc213.svg";